import { AppThunk } from '../../../store/rootReducer';
import * as undoActions from '../actions/undo.actions';

export const undo = (): AppThunk => async (dispatch, getState) => {
  const { undo } = getState();
  const entry = undo.undoStack[undo.undoStack.length - 1];
  if (entry == null) {
    return;
  }

  dispatch(
    undoActions.undo({ diff: entry.toPrevious, meta: { history: false } }),
  );
};
